import {
  MatchClaimsResponse,
  MatchSignalEventsOccurrencesResponse,
} from "shared/api/claims/api";

export const getFilteredData = (
  data: MatchSignalEventsOccurrencesResponse | MatchClaimsResponse | undefined,
  showOnlyRelevantEvents: boolean
) => {
  if (!data) {
    return [];
  }

  if (!showOnlyRelevantEvents && "relatedSignalEventOccurrences" in data) {
    return data.relatedSignalEventOccurrences;
  } else if ("matchedSignalEventOccurrences" in data) {
    return data.matchedSignalEventOccurrences;
  } else if (!showOnlyRelevantEvents && "relatedClaims" in data) {
    return data.relatedClaims;
  }

  return data.matchedClaims ?? [];
};
